/*=========================================================================================
  File Name: modulePersonnel.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleBanqueState.js'
import mutations from './moduleBanqueMutations.js'
import actions from './moduleBanqueActions.js'
import getters from './moduleBanqueGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

